import { useEffect, useState } from "react";
import { setConfirmListener, type ConfirmRequest } from "../lib/confirm";
import { Button, Modal } from "./ui";

/** Renders the single confirmation dialog driven by the `confirm()` helper. */
export function ConfirmHost(): JSX.Element {
  const [req, setReq] = useState<ConfirmRequest | null>(null);

  useEffect(() => setConfirmListener((r) => setReq(r)), []);

  const close = (ok: boolean): void => {
    req?.resolve(ok);
    setReq(null);
  };

  return (
    <Modal open={req !== null} title={req?.title ?? ""} onClose={() => close(false)}>
      {req && (
        <div className="space-y-4">
          {req.message && <p className="text-sm text-slate-600">{req.message}</p>}
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => close(false)}>
              {req.cancelLabel ?? "Cancel"}
            </Button>
            <Button variant={req.danger ? "danger" : "primary"} onClick={() => close(true)}>
              {req.confirmLabel ?? "Confirm"}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
}
